import { atom } from "jotai";
import type { OptionResponse } from "@models/option";

export const optionsAtom = atom<OptionResponse[]>([]);

export const isFetchingOptionsAtom = atom<boolean>(false);

export const isProcessingOptionsAtom = atom<boolean>(false);
